import { SxProps } from '@mui/material';

export const LinkableLinkSX = (variant: string) => {
    switch (variant) {
        case 'primary':
            return {
                textDecoration: 'none',
                color: 'primary.main',
                '&:hover': {
                    textDecoration: 'underline',
                },
            } as SxProps;
        case 'secondary':
            return {
                textDecoration: 'none',
                '&:hover': {
                    color: 'primary.main',
                },
            } as SxProps;
        default:
            return {} as SxProps;
    }
};
